import CheckboxSelectAll from "./checkbox_select_all_controller";

// Connects to data-controller="persistent-checkbox-select-all"
export default class extends CheckboxSelectAll {
  initialize() {
    super.initialize();
    this.selectedIds = new Set();
  }

  connect() {
    super.connect();
    this.checkboxTargets.forEach((cb) => {
      if (cb.checked) this.selectedIds.add(cb.value);
    });

    this.boundChange = this.onChange.bind(this);
    this.element.addEventListener("change", this.boundChange);

    this.boundFrameLoad = this.onFrameLoad.bind(this);
    document.addEventListener("turbo:frame-load", this.boundFrameLoad);

    this.form = this.element.matches("form")
      ? this.element
      : this.element.closest("form");

    this.syncHiddenInputs();
  }

  disconnect() {
    this.element.removeEventListener("change", this.boundChange);
    document.removeEventListener("turbo:frame-load", this.boundFrameLoad);
  }

  checkboxTargetConnected(checkbox) {
    if (this.selectedIds && this.selectedIds.has(checkbox.value)) {
      checkbox.checked = true;
    }
  }

  onFrameLoad(event) {
    if (!this.element.contains(event.target)) return;
    this.checkboxTargets.forEach((cb) => {
      cb.checked = this.selectedIds.has(cb.value);
    });
    this.syncHiddenInputs();
  }

  onChange(event) {
    const target = event.target;
    if (this.checkboxTargets.includes(target)) {
      if (target.checked) {
        this.selectedIds.add(target.value);
      } else {
        this.selectedIds.delete(target.value);
      }
    } else if (
      this.hasCheckboxAllTarget &&
      this.checkboxAllTarget === target
    ) {
      this.checkboxTargets.forEach((cb) => {
        if (target.checked) {
          this.selectedIds.add(cb.value);
        } else {
          this.selectedIds.delete(cb.value);
        }
      });
    } else {
      return;
    }
    this.syncHiddenInputs();
  }

  syncHiddenInputs() {
    if (!this.form) return;
    this.form
      .querySelectorAll("input[data-persistent-checkbox-injected]")
      .forEach((el) => el.remove());

    const visibleIds = new Set(this.checkboxTargets.map((cb) => cb.value));
    this.selectedIds.forEach((id) => {
      if (!visibleIds.has(id)) {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = "ids[]";
        input.value = id;
        input.dataset.persistentCheckboxInjected = "true";
        this.form.appendChild(input);
      }
    });
  }
}
